import classNames from 'classnames'
import React from 'react'

import ArrowIcon from '../../../../assets/icons/simple-arrow.svg'
import useSizes from '../../../../hooks/useSizes'
import { ProgPart } from '../../../../utils/types'
import styles from './PartsMenuItem.module.scss'
import { PartsMenuItemProgressSimple } from './PartsMenuItemProgress'

function PartsMenuSimpleItem({
  item,
  active,
  onClick,
  mobileMain,
  mobileMainOpened,
  playbackPosition,
}: {
  item: ProgPart
  active?: boolean
  onClick?: () => void
  mobileMain?: boolean
  mobileMainOpened?: boolean
  playbackPosition?: any
}) {
  const { isMobile } = useSizes()
  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.mobileMain]: mobileMain,
      })}
    >
      <div
        className={classNames(styles.container, styles.simpleContainer, {
          [styles.active]: active,
          [styles.mobileMain]: mobileMain,
          [styles.mobileMainOpened]: mobileMainOpened,
        })}
        onClick={onClick}
      >
        {!isMobile || mobileMain ? (
          <PartsMenuItemProgressSimple part={item} playbackPosition={playbackPosition} />
        ) : null}
        <div className={styles.loopsCounter}>{item.loops === -1 ? 'Infinite' : item.loops}</div>
        <div className={styles.content}>{item.name}</div>
        {mobileMain && onClick ? (
          <div className={styles.expandIcon}>
            <ArrowIcon />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default PartsMenuSimpleItem
